function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 22.25,
  fill: "white",
  stroke: "#0A0806",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.8999 15.4509C27.6973 15.1671 27.3794 15 27.0417 15H18.4598C18.1221 15 17.8042 15.1671 17.6016 15.4509L15.2151 18.796C14.9169 19.214 14.9311 19.7925 15.2494 20.1939L21.9276 28.6862C22.1314 28.9419 22.4326 29.0897 22.75 29.0897C23.0675 29.0897 23.3687 28.9419 23.5725 28.6862L30.2507 20.1939C30.569 19.7925 30.5832 19.214 30.285 18.796L27.8999 15.4509Z",
  fill: "white",
  stroke: "#0A0806",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7523 15L20.8125 19.7508L22.7523 29.0912",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7523 15L20.8125 19.7508L22.7523 29.0912",
  stroke: "#0A0806",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 19.5093H30.4997H15Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15 19.5093H30.4997",
  stroke: "#0A0806",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgBeneficiaryFormIcon = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "beneficiary-form-icon",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBeneficiaryFormIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/beneficiary-form-icon.69c9a5e9.svg";
export { ForwardRef as ReactComponent };